import VueI18n from "vue-i18n";
// import Cookies from "js-cookie";
import messages from "./messages.js";

let LANG = 'fa';
// try {
//     LANG = Cookies.get("LANG");
// } catch (error) {
//     console.log(error);
//     LANG = "fa";
// }

const i18n = new VueI18n({
    locale: { fa: "fa", en: "en" }[LANG] || "fa",
    messages,
});

Vue.mixin({
    i18n,
});
